export const WAITLIST_GOAL = 500;

export interface TierInfo {
  name: string;
  spots: number;
}

export function getTierInfo(count: number): TierInfo {
  if (count < 100) return { name: 'Grundare', spots: 100 - count };
  if (count < 250) return { name: 'Pionjär', spots: 250 - count };
  if (count < 500) return { name: 'Tidig användare', spots: 500 - count };
  return { name: 'Väntelista', spots: 0 };
}
